module.exports = __webpack_public_path__ + "files/453d4e76f00ba8ee6d198b4c463b8361.svg";